import React from "react";
import { RaisedButton, CircularProgress } from "material-ui";
import { Link } from "react-router";
import Helmet from "react-helmet";

import PassSubscriptionList from "./partials/pass-subscription-list/pass-subscription-list.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../stores/PersonStore";
import PassSubscriptionStore from "../stores/PassSubscriptionStore";
import PassSubscriptionActions from "../actions/PassSubscriptionActions";

@connectToStores
class PassSubscriptions extends React.Component {
  static getStores() {
    return [PersonStore, PassSubscriptionStore];
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  static getPropsFromStores() {
    var props = PassSubscriptionStore.getState();
    props.isLoggedIn = PersonStore.getState().isLoggedIn;
    return props;
  }

  static componentDidConnect(props, context) {
    if (!PersonStore.isLoggedIn()) {
      context.router.replace({
        pathname: "/login",
        query: { next: "/subscriptions" },
        state: {}
      });
    }
  }

  componentDidMount() {
    PassSubscriptionActions.fetchAll();
  }

  getStyles() {
    return {
      container: {
        padding: 10
      },
      intro: {
        padding: 15,
        fontSize: "12pt",
        lineHeight: 1.5,
        color: "rgba(0,0,0,0.54)"
      },
      noPassSubscriptions: {
        padding: "30px 10px",
        textAlign: "center"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    if (!this.props.hasUpdatedAll) {
      return (
        <div style={styles.noPassSubscriptions}>
          <Helmet title="My pass subscriptions" />
          <CircularProgress
            mode="indeterminate"
            size={119}
            thickness={7}
            style={{ margin: 10.5 }}
          />
        </div>
      );
    } else if (
      !this.props.passSubscriptions ||
      Object.keys(this.props.passSubscriptions).length === 0
    ) {
      return (
        <div style={styles.noPassSubscriptions}>
          <Helmet title="My pass subscriptions" />
          {this.props.children
            ? React.cloneElement(this.props.children, {
                appSettings: this.props.appSettings
              })
            : undefined}
          <div style={{ fontSize: "11pt", marginBottom: 10 }}>
            You don't have any subscriptions.
          </div>
          <RaisedButton
            primary={true}
            label="Back to home"
            onClick={() => this.context.router.push("/welcome")}
          />
        </div>
      );
    }

    return (
      <div style={styles.container}>
        <Helmet title="My pass subscriptions" />
        {this.props.children
          ? React.cloneElement(this.props.children, {
              appSettings: this.props.appSettings
            })
          : undefined}
        <div style={styles.intro}>
          These are all the subscriptions tied to your account.
        </div>
        <PassSubscriptionList
          passSubscriptions={this.props.passSubscriptions}
        />
      </div>
    );
  }
}

export default PassSubscriptions;



// WEBPACK FOOTER //
// ./src/app/components/pass-subscriptions.jsx